"use client";

import React, { useState } from "react";
import "./Navbar.css";
import useLockBodyScroll from "@/hooks/useBodyLockScroll";
import closeIcon from "@/assets/svgs/closeIcon.svg";
import Image from "next/image";
import schraubenschluessel from "@/assets/svgs/schraubenschluessel.svg";
import { scrollToSection } from "@/app/helpers/scrollToSection";
import Button from "@/common/Button";
import { useAuth } from "@/context/AuthContext";
import chevronIcon from "@/assets/svgs/chevron.svg";
import carIcon from "@/assets/svgs/carSidebarIcon.svg";
import offeneDealsIcon from "@/assets/svgs/carTag.svg";
import { useRouter } from "next/navigation";
import shoppingbagIcon from "@/assets/svgs/shoppingBag.svg";
import Link from "next/link";
import logoutIcon from "@/assets/svgs/logoutIcon.svg";
import gebuehrenIcon from "@/assets/svgs/offeneDeals.svg";
import notificationIcon from "@/assets/svgs/notification.svg";
import praeferenzenIcon from "@/assets/svgs/praeferenzen.svg";
import saveSearchIcon from "@/assets/svgs/saveSearch.svg";
import tpIcon from "@/assets/treueprogramm/hand_money.svg";

function SidebarRight({ isSidebarOpen, setIsSidebarOpen }) {
  useLockBodyScroll(isSidebarOpen);

  const { userData, logout } = useAuth();
  const router = useRouter();

  const [isGeboteOpen, setIsGeboteOpen] = useState(false);
  const [isPurchasesOpen, setIsPurchasesOpen] = useState(false);

  const pushTo = (path) => {
    setIsSidebarOpen(false);
    router.push(path);
  };

  const hasAccess = userData?.companyInformation?.accessGranted;
  const demoEnded = userData?.companyInformation?.demoEnded;
  const verified = userData?.companyInformation?.verified;

  if (userData) {
    return (
      <div
        className={`sidebarRight ${isSidebarOpen ? "open" : ""} `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="Sidebar-top">
          <button
            className="Sidebar-top-close-icon-wrapper"
            onClick={() => setIsSidebarOpen(false)}
          >
            <Image
              src={closeIcon}
              alt="Schliessen"
              className="Sidebar-top-close-icon"
            />
          </button>
        </div>

        <div className="Sidebar-wrapper-nav">
          <div className="Sidebar-top-items">
            <Link
              className="Sidebar-company-section"
              href={
                hasAccess ? "/profil/unternehmensinformation" : "/verifikation"
              }
              onClick={() => setIsSidebarOpen(false)}
            >
              <div className="Sidebar-text-wrapper">
                <h4 className="Sidebar-company-title">
                  {userData.vorname} {userData.nachname}
                </h4>

                <span className="Sidebar-company-name">
                  {userData.firmenname}
                </span>
              </div>

              {hasAccess && (
                <Image
                  src={chevronIcon}
                  alt="chevron"
                  className="Sidebar-company-chevron"
                />
              )}
            </Link>

            {(verified || (hasAccess && !demoEnded)) && (
              <>
                <div className="Sidebar-line-wrapper">
                  <div className="Sidebar-line"></div>
                </div>

                <div
                  className="Sidebar-top-item"
                  onClick={() => {
                    pushTo("/marktplatz");
                  }}
                >
                  <div className="Sidebar-top-item-left">
                    <Image
                      src={carIcon}
                      alt="Marktplatz"
                      className="Sidebar-top-item-icon"
                    />
                    <span className="Sidebar-top-item-text">Marktplatz</span>
                  </div>

                  <div className="Sidebar-top-item-right"></div>
                </div>

                <div
                  className="Sidebar-top-item"
                  onClick={() => {
                    pushTo("/profil/gebuehren");
                  }}
                >
                  <div className="Sidebar-top-item-left">
                    <Image
                      src={gebuehrenIcon}
                      alt="Gebühren"
                      className="Sidebar-top-item-icon"
                    />
                    <span className="Sidebar-top-item-text">Gebühren</span>
                  </div>

                  <div className="Sidebar-top-item-right"></div>
                </div>

                <div
                  className="Sidebar-top-item"
                  onClick={() => {
                    pushTo("/profil/benachrichtigungscenter");
                  }}
                >
                  <div className="Sidebar-top-item-left">
                    <Image
                      src={notificationIcon}
                      alt="Notification Icon"
                      className="Sidebar-top-item-icon"
                    />
                    <span className="Sidebar-top-item-text">
                      Benachrichtigungen
                    </span>
                  </div>

                  <div className="Sidebar-top-item-right"></div>
                </div>

                <div
                  className="Sidebar-top-item"
                  onClick={() => {
                    pushTo("/profil/praeferenzen");
                  }}
                >
                  <div className="Sidebar-top-item-left">
                    <Image
                      src={praeferenzenIcon}
                      alt="Präferenzen Icon"
                      className="Sidebar-top-item-icon"
                    />
                    <span className="Sidebar-top-item-text">Präferenzen</span>
                  </div>

                  <div className="Sidebar-top-item-right"></div>
                </div>

                <div
                  className="Sidebar-top-item"
                  onClick={() => {
                    pushTo("/profil/gespeicherte-suchen");
                  }}
                >
                  <div className="Sidebar-top-item-left">
                    <Image
                      src={saveSearchIcon}
                      alt="Gespeicherte suchen"
                      className="Sidebar-top-item-icon"
                    />
                    <span className="Sidebar-top-item-text">
                      Gespeicherte Suchen
                    </span>
                  </div>
                </div>

                <div
                  className="Sidebar-top-item"
                  onClick={() => {
                    pushTo("/treueprogramm");
                  }}
                >
                  <div className="Sidebar-top-item-left">
                    <Image
                      src={tpIcon}
                      alt="Treueprogramm"
                      className="Sidebar-top-item-icon"
                    />
                    <span className="Sidebar-top-item-text">Treuprogramm</span>
                  </div>
                </div>

                <div
                  className={`Sidebar-accordion-wrapper ${
                    isGeboteOpen ? "open" : ""
                  }`}
                >
                  <div
                    className="Sidebar-accordion-opener"
                    onClick={() => {
                      setIsGeboteOpen(!isGeboteOpen);
                      setIsPurchasesOpen(false);
                    }}
                  >
                    <div className="Sidebar-top-item-left">
                      <Image
                        src={offeneDealsIcon}
                        alt="Offene Deals"
                        className="Sidebar-top-item-icon"
                      />
                      <span className="Sidebar-top-item-text">
                        Offene Deals
                      </span>
                    </div>

                    <div className="Sidebar-top-item-right">
                      <Image
                        src={chevronIcon}
                        alt="chevron"
                        className={`Sidebar-top-item-chevron ${
                          isGeboteOpen ? "open" : ""
                        }`}
                      />
                    </div>
                  </div>

                  <div className="Sidebar-accordion-items">
                    <Link
                      onClick={() => setIsSidebarOpen(false)}
                      href="/profil/gebote/aktiv"
                      className="Sidebar-accordion-item"
                    >
                      <span>Aktiv</span>
                    </Link>
                    <Link
                      onClick={() => setIsSidebarOpen(false)}
                      href="/profil/gebote/im-prozess"
                      className="Sidebar-accordion-item"
                    >
                      <span>Im Prozess</span>
                    </Link>
                    <Link
                      onClick={() => setIsSidebarOpen(false)}
                      href="/profil/gebote/nicht-gewonnen"
                      className="Sidebar-accordion-item"
                    >
                      <span>Nicht gewonnen</span>
                    </Link>
                  </div>
                </div>

                <div
                  className={`Sidebar-accordion-wrapper ${
                    isPurchasesOpen ? "open" : ""
                  }`}
                >
                  <div
                    className="Sidebar-accordion-opener"
                    onClick={() => {
                      setIsPurchasesOpen(!isPurchasesOpen);
                      setIsGeboteOpen(false);
                    }}
                  >
                    <div className="Sidebar-top-item-left">
                      <Image
                        src={shoppingbagIcon}
                        alt="Offene Deals"
                        className="Sidebar-top-item-icon"
                      />
                      <span className="Sidebar-top-item-text">Käufe</span>
                    </div>

                    <div className="Sidebar-top-item-right">
                      <Image
                        src={chevronIcon}
                        alt="chevron"
                        className={`Sidebar-top-item-chevron ${
                          isPurchasesOpen ? "open" : ""
                        }`}
                      />
                    </div>
                  </div>

                  <div className="Sidebar-accordion-items">
                    <Link
                      onClick={() => setIsSidebarOpen(false)}
                      href="/profil/gebote/abgeschlossen"
                      className="Sidebar-accordion-item"
                    >
                      <span>Abgeschlossen</span>
                    </Link>
                    <Link
                      onClick={() => setIsSidebarOpen(false)}
                      href="/profil/gebote/nicht-gewonnen"
                      className="Sidebar-accordion-item"
                    >
                      <span>Storniert</span>
                    </Link>
                  </div>
                </div>
              </>
            )}
          </div>

          <div className="Sidebar-bottom-items">
            <div className="Sidebar-line-wrapper">
              <div className="Sidebar-line"></div>
            </div>
            <div
              className="Sidebar-top-item"
              onClick={() => {
                setIsSidebarOpen(false);
                logout();
              }}
            >
              <div className="Sidebar-top-item-left">
                <Image
                  src={logoutIcon}
                  alt="schraubenschluessel"
                  className="Sidebar-top-item-icon"
                />
                <span className="Sidebar-top-item-text">Ausloggen</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`sidebarRight ${isSidebarOpen ? "open" : ""} `}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="Sidebar-top">
          <button
            className="Sidebar-top-close-icon-wrapper"
            onClick={() => setIsSidebarOpen(false)}
          >
            <Image
              src={closeIcon}
              alt="Schliessen"
              className="Sidebar-top-close-icon"
            />
          </button>
        </div>

        <div className="Sidebar-wrapper-nav">
          <div className="Sidebar-top-items">
            <div
              className="Sidebar-top-item"
              onClick={() => {
                setIsSidebarOpen(false);
                scrollToSection("how-it-works");
              }}
            >
              <div className="Sidebar-top-item-left">
                <Image
                  src={schraubenschluessel}
                  alt="schraubenschluessel"
                  className="Sidebar-top-item-icon"
                />

                <span className="Sidebar-top-item-text active">
                  So Funktionierts
                </span>
              </div>
            </div>
          </div>

          <div className="Sidebar-bottom-items">
            <Button
              link={"/login"}
              isSecondary
              marginBottom="16px"
              onClick={() => setIsSidebarOpen(false)}
            >
              Login
            </Button>
            <Button
              link={"/registrieren"}
              onClick={() => setIsSidebarOpen(false)}
            >
              Jetzt Registrieren
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default SidebarRight;
